import { useState, useRef, useEffect, useMemo } from 'react'
import { Background, type BackgroundCameraControls } from '@app/components/background'

import './App.scss'
import { HomePage } from '@app/pages/home'
import { useScrollTrigger } from '@app/hooks/useScrollTrigger'
import { ContactPage } from '@app/pages/contact'
import { PageWrapper } from '@app/components/page-wrapper'
// import { InfoPage } from '@app/pages/info'
import { ScrollContext } from '@app/context/scroll-context'
import { RecaptchaProvider } from '@app/components/recaptcha'

const recaptchaKey = (import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? '') as string

const TOTAL_PAGE_COUNT = 2

function App() {
  const [sceneKey, /*setSceneKey*/] = useState(0)
  const [theme, /*setTheme*/] = useState<'light' | 'dark'>('dark')
  const [isDimmed, /*setIsDimmed*/] = useState(false)
  const [pageIndex, setPageIndex] = useState(0)

  const mainRef = useRef<HTMLElement | null>(null)

  const backgroundCamera = useRef<BackgroundCameraControls>(null)

  // const handleReloadScene = useCallback(() => setSceneKey((k) => k + 1), [])

  // const handleColourMode = useCallback(() => {
  //   const next = theme === 'light' ? 'dark' : 'light'
  //   document.body.setAttribute('data-theme', next)
  //   setTheme(next)
  //   setTimeout(() => setSceneKey((k) => k + 1), 100)
  // }, [theme])

  // set body data theme attribute
  useEffect(() => {
    document.body.setAttribute('data-theme', theme)
  }, [theme])

  const { goToPage } = useScrollTrigger(mainRef, TOTAL_PAGE_COUNT, {
    onPageChange: (idx) => {
      setPageIndex(idx)

      if (idx === 0) backgroundCamera.current?.setCameraPosition1()
      else if (idx === 1) backgroundCamera.current?.setCameraPosition2()
      else backgroundCamera.current?.setCameraPosition3()
    },
  })

  const scrollContext = useMemo(() => ({ goToPage, currentPage: pageIndex }), [goToPage, pageIndex])

  return (
    <ScrollContext.Provider value={scrollContext}>
      <RecaptchaProvider recaptchaKey={recaptchaKey}>
        <Background key={sceneKey} ref={backgroundCamera} isDimmed={isDimmed} />
        <PageWrapper ref={mainRef} pageIndex={pageIndex} goToPage={goToPage}>
          <HomePage />
          <ContactPage />
        </PageWrapper>
      </RecaptchaProvider>
    </ScrollContext.Provider>
  )
}

export default App
